import { Map, Set } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import { combineReducers } from 'redux-immutable'
import * as actions from './actions'

const ui = handleActions({
  [actions.setModalVisibility]: (state, action) => {
    return action.payload
  }
}, false)

const status = handleActions({
  [actions.receiveParticipants]: (state, action) => {
    return state.set('conversationId', action.payload.conversationId)
  },

  [combineActions(
    actions.fetchParticipants,
    actions.fetchParticipantsPending,
    actions.fetchParticipantsFailed,
    actions.fetchParticipantsCancelled,
    actions.receiveParticipants,
  )]: (state, action) => {
    return state.set('fetch', action.type)
  },

  [combineActions(
    actions.addParticipants,
    actions.addParticipantsPending,
    actions.addParticipantsFailed,
    actions.addParticipantsSuccess,
  )]: (state, action) => {
    return state.set('add', action.type)
  },

  [combineActions(
    actions.removeParticipants,
    actions.removeParticipantsPending,
    actions.removeParticipantsFailed,
    actions.removeParticipantsSuccess,
  )]: (state, action) => {
    return state.set('remove', action.type)
  },
}, Map())

const data = handleActions({
  [actions.receiveParticipants]: (state, action) => {
    return action.payload.participants
  },

  // TODO: Support teams?
  [combineActions(
    actions.addParticipantsPending,
    actions.removeParticipantsFailed,
  )]: (state, action) => {
    return state.union(action.payload.participants)
  },

  // TODO: Support teams?
  [combineActions(
    actions.removeParticipantsPending,
    actions.addParticipantsFailed,
  )]: (state, action) => {
    return state.subtract(action.payload.participants)
  },
}, Set())

export default combineReducers({ status, data, ui })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/participants/reducer.js